import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UserPen, Mail, LoaderCircle, Phone } from 'lucide-react';
import logo from "../../../../../assets/image/logo.png";
import CryptoJS from "crypto-js";
import { getCustomerByUserId, SignUp } from '../../../../redux/reduxApi/SingIn&SingUp/SingUpApi';
import { AddCustomerApi, checkCustomerEmail } from '../../../../redux/reduxApi/admin/CustomerReduxApi';
import { useNavigate } from 'react-router-dom';

const SECRET_KEY = "6454gfdydt46465";

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(data.toString(), SECRET_KEY).toString();
};

export const decryptData = (cipherText) => {
  const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
};

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);
  const bgColor = type === 'success' ? 'bg-green-500' : 'bg-red-500';
  return (
    <div className={`fixed top-5 left-1/2 transform -translate-x-1/2 z-50 ${bgColor} text-white px-6 py-3 rounded-lg shadow-lg transition-all duration-300`}>
      {message}
    </div>
  );
};

export const Login2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, error } = useSelector((state) => state.SignUp);

  const [isLoginView, setIsLoginView] = useState(true);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email_id: '',
    mobile: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });

  const showToast = (message, type) => {
    setToast({ show: true, message, type });
  };
  const hideToast = () => setToast({ show: false, message: '', type: '' });

  // Monitor Redux status for signup result
  useEffect(() => {
    if (status === 'fulfilled') {
      showToast("Signup successful! Check Your Email and Create Passoword", "success");
      setIsLoginView(true);
      setFormData({ first_name: '', last_name: '', email_id: '', mobile: '' });
      setIsLoading(false);
    } else if (status === 'failed' && error) {
      // Show the exact error message from backend
      let errorMsg = error;
      // Optional: custom message for duplicate email
      if (error.toLowerCase().includes('email') && error.toLowerCase().includes('exist')) {
        errorMsg = "Email already exists. Please try with a different email.";
      }
      showToast(errorMsg, "error");
      setIsLoading(false);
    }
  }, [status, error]);

  // Catalyst login init (unchanged)
  useEffect(() => {
    const config = {
      css_url: "/app/css/embeddediframe.css",
      is_customize_forgot_password: true,
      service_url: "/app/index.html",
      forgot_password_id: "forgotPasswordDivElementId",
      forgot_password_css_url: "/app/css/forgotPwd.css",
    };
    if (window.catalyst) {
      window.catalyst.auth.signIn("forgotPasswordDivElementId", config);
      console.log("Catalyst sign-in initialized");
    } else {
      console.error("Catalyst SDK not loaded");
    }
  }, []);

  
  useEffect(() => {
    if (!window.catalyst) return;

    const userManagement = window.catalyst.userManagement;
    console.log("Checking user authentication status...",userManagement);
    userManagement.getCurrentProjectUser()
      .then(async (response) => {
        console.log("Checking userrrrr authentication status...",response);

        if (response?.content?.is_confirmed) {
          const userId = response.content.user_id;
          const firstName = response.content.first_name;
          const lastName = response.content.last_name;
          const email = response.content.email_id;
          if (response.content.source === "Google") {
            try {
              const emailCheck = await dispatch(checkCustomerEmail({ email: email }));
              console.log("checkCustomerEmail response ", emailCheck);
              if (!emailCheck.payload.exists) {
                const resp = await dispatch(AddCustomerApi({ firstName: firstName, lastName: lastName, email: email, userId: userId ,isVerified:response.content.is_confirmed,orgId:response.content.org_id}));
                console.log("AddCustomerApi response:", resp);
              }
            } catch (err) {
              console.error("Error in Google login flow: ", err);
            }
          }
          try {
            const res = await dispatch(getCustomerByUserId({ id: userId }));
            console.log("res", res);

            if (res?.payload?.success || res?.data?.success) {
              const customerId = res?.payload?.customer?.ROWID;
              if (customerId) {
                localStorage.setItem("customerId", customerId);
              }
              console.log("Customer data sync successful");
            }
          } catch (dispatchErr) {
            console.error("Error fetching customer:", dispatchErr);
          }



          const encrypted = encryptData(userId);
          localStorage.setItem("authToken", encrypted);
          localStorage.setItem("userId", userId);
          localStorage.setItem("firstName", firstName);
          localStorage.setItem("lastName", lastName);
          localStorage.setItem("email", email);
          window.dispatchEvent(new Event("appUserLoggedIn"));
          navigate("/homepage"); 

        } else {
          navigate("/login");
        }
      })
      .catch((err) => console.log(err));
  }, [dispatch, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // const handleSignup = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);

  //   const response = dispatch(SignUp(formData));
  //   console.log("response",response)
  //   if (!response.success){
  //     if(response.error.message === "Duplicate value for Email ID. Please give a different value"){
  //       showToast("User Already Exists", "error");
  //     }
  //     else {
  //       showToast(response.error.message, "error");
  //     }
  //   }
  //   else{
  //     showToast("Signup successful! Please log in.", "success");
  //   }
  // };

  const handleSignup = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await dispatch(SignUp(formData)).unwrap();
      showToast("Signup successful! Please log in.", "success");
      setIsLoginView(true);
      setFormData({ first_name: '', last_name: '', email_id: '', mobile: '' });
    } catch (err) {
      let message = err;
      if (typeof err === 'object' && err.message) message = err.message;
      if (message.toLowerCase().includes('email') && message.toLowerCase().includes('exist')) {
        message = "Email already exists. Please try with a different email.";
      }
      showToast(message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex h-[80vh] justify-center items-center mt-20 w-full">
      {toast.show && <Toast message={toast.message} type={toast.type} onClose={hideToast} />}

      <div className="flex shadow-lg rounded-xl overflow-hidden border border-gray-200">
        <div className="bg-white flex flex-col justify-center">
          <div
            style={{ width: "500px" }}
            className={`${isLoginView ? "block" : "hidden"} p-3 h-[80vh] overflow-hidden`}
            id="forgotPasswordDivElementId"
          />

          <div className={isLoginView ? "hidden" : "block w-[500px] pb-20"}>
            <form className="formClass h-[80vh]" onSubmit={handleSignup}>
              <p className="mb-4 text-4xl font-bold text-blue-900 pb-10 mt-0">Create Account</p>

              <div className="d-flex rounded-[30px] bg-[#EEEEEE] text-center border border-blue-900 mb-3 items-center"
                style={{ background: "#EEEEEE", width: "99%", height: "43px", display: "flex" }}>
                <span className="flex items-center ml-2 text-gray-500"><UserPen className="size-6" /></span>
                <input type="text" name="first_name" placeholder="First Name" required onChange={handleChange}
                  className="focus:outline-none border-0 px-2 py-2 w-full bg-transparent" />
              </div>

              <div className="d-flex rounded-[30px] bg-[#EEEEEE] text-center border border-blue-900 mb-3 items-center"
                style={{ background: "#EEEEEE", width: "99%", height: "43px", display: "flex" }}>
                <span className="flex items-center ml-2 text-gray-500"><UserPen className="size-6" /></span>
                <input type="text" name="last_name" placeholder="Last Name" required onChange={handleChange}
                  className="focus:outline-none border-0 px-2 py-2 w-full bg-transparent" />
              </div>

              <div className="d-flex rounded-[30px] bg-[#EEEEEE] text-center border border-blue-900 mb-3 items-center"
                style={{ background: "#EEEEEE", width: "99%", height: "43px", display: "flex" }}>
                <span className="flex items-center ml-2 text-gray-500"><Mail className="size-6" /></span>
                <input type="email" name="email_id" placeholder="Email" required onChange={handleChange}
                  className="focus:outline-none border-0 px-2 py-2 w-full bg-transparent" />
              </div>

              <div className="d-flex rounded-[30px] bg-[#EEEEEE] text-center border border-blue-900 mb-1 items-center"
                style={{ background: "#EEEEEE", width: "99%", height: "43px", display: "flex" }}>
                <span className="flex items-center ml-2 text-gray-500"><Phone className="size-5" /></span>
                <input type="tel" name="mobile" placeholder="Mobile" required onChange={handleChange}
                  className="focus:outline-none border-0 px-2 py-2 w-full bg-transparent" />
              </div>

              <button
                disabled={isLoading}
                type="submit"
                className="signup-button mt-4 text-blue-900 w-full bg-blue-100 py-2 rounded-full font-semibold hover:bg-blue-200 transition"
              >
                {isLoading ? (
                  <div className="flex justify-center items-center gap-2">
                    <LoaderCircle className="size-4 animate-spin" />
                    <span>Loading..</span>
                  </div>
                ) : (
                  "Sign Up"
                )}
              </button>
            </form>
          </div>
        </div>

        <div style={{ background: "linear-gradient(to right, #2c3264, #034c8c)" }}
          className="w-[500px] h-[80vh] p-8 flex flex-col justify-center items-center text-white text-center">
          <img src={logo} alt="Logo" style={{ width: "400px", height: "auto" }} className="mb-8" />
          {isLoginView ? (
            <>
              <h1 className="text-4xl font-bold mb-2">Welcome Back!</h1>
              <p className="text-xl mb-6">To keep connected with us please login with your personal info</p>
              <button className="bg-white text-blue-500 font-semibold py-2 px-6 rounded-full hover:bg-gray-100 transition"
                onClick={() => setIsLoginView(false)}>Sign Up</button>
            </>
          ) : (
            <>
              <h1 className="text-4xl font-bold mb-2">Join Us!</h1>
              <p className="text-xl mb-6">Enter your personal details and start your journey with us</p>
              <button className="bg-white text-blue-500 font-semibold py-2 px-6 rounded-full hover:bg-gray-100 transition"
                onClick={() => setIsLoginView(true)}>Sign In</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};